import client from 'providers/fetchClient'

const BASE_API_ENDPOINT = '/beneficiaries-groups'

export const fetchAll = async ({ search, sortBy, pagination }) => {
  const params = { search }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get(BASE_API_ENDPOINT, { params })

  const beneficiaryGroups = data.data.map(group => ({
    ...group,
    packages: group.packages_list.map(({ name }) => name).join(', '),
  }))

  return {
    beneficiaryGroups,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const removeBeneficiary = async ({ groupID, beneficiaryID }) =>
  client.delete(`${BASE_API_ENDPOINT}/${groupID}/beneficiaries/${beneficiaryID}`)

export default {
  fetchAll,
  removeBeneficiary,
}
